import React, { Component } from "react";
import { Col, Row } from "reactstrap";

class Obj extends Component {
  render() {
    return (
      <Row>
        <Col xs="12">
          <h1>
            かんもしWeb成績表&ensp;
            <img
              src="images/kanmoshi_logo.png"
              className="logo"
              alt="logo"
            ></img>
          </h1>
          <p className="text-muted">
            <span className="small">
              Web成績表へのログインは、ご実施されたマークシートが弊社に到着してから2～5営業日内に「Web成績表閲覧開始のご案内」のメールが到着した段階よりご覧いただけます。
              <br />
              ＊マークシート到着日および土日祝日は営業日に含みません。
              <br />
              ＊ログイン情報とは、かんもしIDおよびパスワードです。
              <br />
              <br />
              ●ご担当先生へ
              <br />
              マークシートの読み込みが完了し、web成績表をご覧いただける状態になりましたらメールで
              かんもしID、パスワードをお知らせいたします。
              <br />
              ●受験生の方へ
              <br />
              成績の閲覧が可能になりましたらご担当の先生へお知らせいたします。
              <br />
              （マークシートが弊社に到着後2～5営業日でご覧いただけます）
              <br />
            </span>
            <span className="small" style={{ color: "#ff0000" }}>
              ※受験生の皆さまへ
              <br />
              メンテナンスに伴い、4月27日～5月29日の期間中にパスワードの変更を行われた方のパスワードを初期化させていただきました。
              <br />
              お手数をおかけし誠に恐縮ではございますが、ログインの際は初期パスワードをご使用くださいますようお願い申し上げます。
            </span>
          </p>
        </Col>
      </Row>
    );
  }
}

export default Obj;
